import { FC, useMemo, useState, useCallback, useContext } from "react";

import Select from "react-select";

import useAxios from "../../../services/useAxios";
import CustomButton from "../../kits/button/CustomButton";

import PreparedMessagesCard from "./PreparedMessageCard";

import {
  ChatSendMessageRequest,
  ChatSendMessageResponse,
  MessageType,
  SelectOptionsType,
} from "./PrMeTypes";
import { toast } from "react-hot-toast";
import AuthenticationContext from "../../../Authentication/AuthenticationContext";

interface PreparedMessagesTableProps {
  messages: MessageType[];
  categories: SelectOptionsType;
  receiver_id: string;
  deleteMessage: (id: number) => void;
  selectedContact: { customer_id: string };
}

const PreparedMessagesTable: FC<PreparedMessagesTableProps> = ({
  messages,
  categories,
  receiver_id,
  deleteMessage,
  selectedContact,
}) => {
  const { userInfo } = useContext(AuthenticationContext);

  const { execute: ChatSendMessage } = useAxios("/api/chat_send_message");
  const [categoryId, setCategoryId] = useState(0);

  const [selectedMessages, setSelectedMessages] = useState<MessageType[]>([]);

  const filteredMessages = useMemo(
    () => messages.filter((val) => val.category_id === categoryId),
    [messages, categoryId]
  );

  const selectMessage = useCallback((message: MessageType, state: boolean) => {
    if (state) {
      setSelectedMessages((prev) => [...prev, message]);
    } else {
      setSelectedMessages((prev) =>
        prev.filter((val) => val.id !== message.id)
      );
    }
  }, []);

  const sendMessages = useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(async () => {
    if (selectedMessages.length === 0) {
      toast.error("لطلفا حداقل یک پیام را انتخاب نمایید.");
      return;
    }

    let results = await Promise.all(
      selectedMessages.map(async (val) => {
        let data: ChatSendMessageRequest = {
          sender_id: userInfo.id,
          receiver_id,
          text: val.text,
          file_id: "" + val.file_id,
          customer_id: selectedContact.customer_id,
        };

        return await ChatSendMessage(data).then(
          (res: ChatSendMessageResponse) => res.status === 1
        );
      })
    );

    if (!results.includes(false)) {
      toast.success("پیام‌ها با موفقیت ارسال شدند.");
    } else {
      toast.success(
        "مشکلی در ارسال پیام‌ها بوجود آماده است، لطفا بعدا تلاش کنید."
      );
      setSelectedMessages([]);
    }
  }, [selectedMessages, userInfo.id, receiver_id, ChatSendMessage]);

  return (
    <>
      <div className="mt-3">
        <Select
          options={categories}
          value={categories.find((val) => +val.value === categoryId)}
          onChange={(newValue) => {
            newValue?.value && setCategoryId(+newValue.value);
            setSelectedMessages([]);
          }}
          placeholder="دسته‌بندی مورد نظر را انتخاب نمایید..."
        />
      </div>
      <div className="prepared-message-modal-table">
        {filteredMessages.map((val, index) => {
          let checked =
            selectedMessages.findIndex((msg) => val.id === msg.id) !== -1;
          return (
            <PreparedMessagesCard
              key={`prepared-message-card-${val.id}`}
              message={val}
              checked={checked}
              deleteMessage={() => deleteMessage(val.id)}
              selectMessage={() => selectMessage(val, !checked)}
            />
          );
        })}
      </div>
      <div className="d-flex justify-content-center mt-3">
        <CustomButton color="primary" className="" onClick={sendMessages}>
          ارسال پیام
        </CustomButton>
      </div>
    </>
  );
};

export default PreparedMessagesTable;
